import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { Link, withRouter } from 'react-router-dom';
import { checkSipSubscribed, handleLogout } from '../../../../services/helperFunctions';
import { ImgLazyload, Avatar } from '../index';
// import Logo from '../../../public/images/ketto-new-logo.png';
import DownIcon from '../../../public/images/icon-down.png';
import WA from '../../../public/images/icon-wa-green.png';
import './navbar.scss';
import SwipeableTemporaryDrawer from '../SideBar/index';
import { UserLoginContext } from '../../../../contexts/LoggedInUserContext';
import { getWalletSummary } from '../../../../redux/actions/WalletSummary';
import DonorIcon from '../../../public/images/donor_icon.png';
import KettoLogo from '../../../public/images/logo-light-bg.svg';

class Navbar extends Component {
  static contextType = UserLoginContext;

  constructor(props) {
    super(props);
    this.state = {
      isDropDownOpen: false,
      isDropDownOpen2: false,
      wallet: '',
      // userData: {},
    };
  }

  componentDidMount() {
    // setTimeout(() => {
    //   this.handleUserData();
    // }, 500);
   
  }

  handleToggleDropdown = () => {
    const { isDropDownOpen } = this.state;
    // const x = window.matchMedia('(max-width: 480px)');
    this.handleWalletLedger();
    setTimeout(() => {
      this.setState({ isDropDownOpen: !isDropDownOpen });
      if (!isDropDownOpen === true) {
        document.addEventListener('click', this.handleOutsideClick);
      }
    }, 500);
  }

  handleToggleDropdownPop = (open) => (event) => {
    const { state } = this;
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    this.setState({ ...state, isDropDownOpen2: open });
    this.handleWalletLedger();
  };

  handleToggleDropdownPopClose = () => {
    this.setState({ isDropDownOpen2: false });
  }

  handleUserData = () => {
    const data = JSON.parse(localStorage.getItem('userdata'));
    // this.setState({
    //   userData: data,
    // });
  }

  handleOutsideClick = (event) => {
    const { isDropDownOpen } = this.state;
    const exemptedCls = ['down-arrow', 'profile-icon', 'p-2 cursor-poiner dropdown-item'];

    if (event && isDropDownOpen && !exemptedCls.includes(event.target.className)) {
      this.setState({ isDropDownOpen: false });
    }
  }

  handleRedirection = (url, isRoute = false) => {
    const { history } = this.props;
    const { state } = this;
    if (isRoute) { this.setState({ ...state, isDropDownOpen2: false }); history.push(url); } else { window.location.href = url; }
  }

  handleWhatsApp = (url) => {
    window.open(url, '_blank');
  }

  getWidth = () => {
    if (self.innerWidth) {
      return self.innerWidth;
    }

    if (document.documentElement && document.documentElement.clientWidth) {
      return document.documentElement.clientWidth;
    }

    if (document.body) {
      return document.body.clientWidth;
    }
  }

  handleWalletLedger = () => {
    const { userData } = this.context || {};
    if (userData?.wallet_balance) {
      getWalletSummary(userData?.id, 1).then((res) => {
        this.setState({ wallet: res.data.data.data });
      });
    }
  }

  render() {
    // const { isDropDownOpen, isDropDownOpen2 } = this.state;
    const { userData, latestOrder } = this.context;
    const { isDropDownOpen, isDropDownOpen2, wallet } = this.state;
    const { avtar = null, user_details_id = '', full_name = '' } = userData || {};
    const domain = document.location.href.includes('devsip') || document.location.href.includes('localhost') ? 'https://dev5.ketto.org' : 'https://ketto.org';
    const whatsApp = navigator && navigator.userAgentData && navigator.userAgentData.mobile ? 'api' : 'web';
    const hiddenNav = ['/sipprotect', '/teleconsult', '/gooddeeds'];
    const isVisible = !hiddenNav.includes(document.location.pathname);
    const { history } = this.props;
    const isSubscribed = checkSipSubscribed(userData?.listsubscriptions);

    return (
      <div className={`navbar ${!isVisible ? 'hidden' : ''}`}>
        <div className="navbar-container">
          <div className="logo-container" onClick={() => this.handleRedirection(domain)}>
            <ImgLazyload
              data-src={KettoLogo}
              src={KettoLogo}
              className="cursor-pointer"
              alt="ketto Logo" />
          </div>
          <div className="profile-container">
            <div className="profile-v2 web-hide" onClick={this.handleToggleDropdownPop(true)}>
              <div className="progress" style={{ background: 'radial-gradient(closest-side, #FCFCFC 79%, transparent 80% 100%), conic-gradient(#36BEC7 ' + userData?.profile_complate + '%, #FCFCFC 0)' }}></div>
              <div className="outline">
                <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
              </div>
            </div>
            <div className="profile-v2 mob-hide" onClick={this.handleToggleDropdown}>
              <div className="progress" style={{ background: 'radial-gradient(closest-side, #FCFCFC 79%, transparent 80% 100%), conic-gradient(#36BEC7 ' + userData?.profile_complate + '%, #FCFCFC 0)' }}></div>
              <div className="outline">
                <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
              </div>
            </div>
            {/* <div className="profile-icon web-hide" onClick={this.handleToggleDropdownPop(true)}>
              <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
            </div>
            <div className="profile-icon mob-hide" onClick={this.handleToggleDropdown}>
              <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
            </div>
            <div
              onClick={this.handleToggleDropdown}
              style={{ display: 'flex', alignItems: 'center' }}
              className="down-arrow mx-1 downarr">
              <LazyLoad>
                <img
                    src={DownIcon}
                    alt="ketto Logo"
                    className="cursor-pointer"
                    style={{ width: '7px', height: '5px' }} />
              </LazyLoad>
            </div> */}
            {isDropDownOpen
              && window.innerWidth > 480 ? (
                <ul className="profile-dropdown-list py-2 bg-white">
                  {full_name && (
                  <li className="cursor-poiner name text-bold">
                    {full_name}
                  </li>
                  )}
                  <li className="cursor-poiner dropdown-item" onClick={() => { history.push('/editprofile'); }}>
                    View Profile
                  </li>
                  <li className="cursor-poiner dropdown-item" onClick={() => { history.push('/mydonations'); }}>
                    My Donations
                  </li>
                  { wallet.length != 0 && (
                  <li className="cursor-poiner dropdown-item" onClick={() => { history.push('/mywallet'); }}>
                    My Wallet
                  </li>
                  )}
                  {isSubscribed && (
                  <li className="cursor-poiner dropdown-item" onClick={() => history.push(latestOrder && latestOrder.status_flag != 1 ? '/inactiveuser' : '/')}>
                    My SIP Dashboard
                  </li>
                  )}
                  <li className="cursor-poiner dropdown-item" onClick={() => handleLogout()}>
                    Logout
                  </li>
                </ul>
              )
              : (
                <SwipeableTemporaryDrawer
                 value={isDropDownOpen2}
                 toggleDrawer={this.handleToggleDropdownPop}
                 userData={userData}
                 handleRedirection={this.handleRedirection}
                 wallet={wallet} />
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Navbar);
